import { memo } from 'react';
import { Box, Table, TableContainer } from '@mui/material';
import CustomTablePagination from 'components/cmn/CustomTablePagination';
import { ICmnTableBoxProps } from 'interface/cmn/commonInfo';

function CustomTable({
  children,
  count,
  rowsPerPage,
  page,
  onPageChange,
  onRowsPerPageChange,
  isLoading,
  maxHeight = 'calc(100vh - 272px)',
  duration,
  isPagination = true,
}: ICmnTableBoxProps): JSX.Element {
  return (
    <Box>
      <TableContainer
        sx={{
          width: '100%',
          overflowX: 'auto',
          position: 'relative',
          display: 'block',
          maxWidth: '100%',
          '& td, & th': { whiteSpace: 'nowrap' },
          maxHeight,
          minHeight: 120,
          height: 'auto',
        }}
      >
        <Table
          stickyHeader
          aria-labelledby="tableTitle"
          sx={{
            '& .MuiTableCell-root:first-of-type': {
              pl: 2,
            },
            '& .MuiTableCell-root:last-child': {
              pr: 3,
            },
          }}
        >
          {children}
        </Table>
      </TableContainer>
      {isPagination && (
        <CustomTablePagination
          count={count as number}
          rowsPerPage={rowsPerPage as number}
          page={page as number}
          onPageChange={onPageChange as (event: unknown, newPage: number) => void}
          onRowsPerPageChange={onRowsPerPageChange as (event: React.ChangeEvent<HTMLInputElement>) => void}
          isLoading={isLoading as boolean}
          duration={duration as number}
        />
      )}
    </Box>
  );
}

export default memo(CustomTable);
